var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.1666 11.667L18.6666 11.667L14 17.5003L9.33329 11.667L12.8333 11.667L12.8333 1.16699L15.1666 1.16699L15.1666 11.667ZM10.5 2.86776L10.5 5.34543C7.07952 6.73 4.66663 10.0834 4.66663 14.0003C4.66663 19.155 8.84527 23.3337 14 23.3337C19.1546 23.3337 23.3333 19.155 23.3333 14.0003C23.3333 10.0834 20.9204 6.73 17.5 5.34543L17.5 2.86776C22.2333 4.35441 25.6666 8.77641 25.6666 14.0003C25.6666 20.4436 20.4433 25.667 14 25.667C7.55669 25.667 2.33329 20.4436 2.33329 14.0003C2.33329 8.77641 5.76668 4.35441 10.5 2.86776Z",
    fill: "#191A51"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.1666 11.667L18.6666 11.667L14 17.5003L9.33329 11.667L12.8333 11.667L12.8333 1.16699L15.1666 1.16699L15.1666 11.667Z",
    fill: "#FF6600"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIn);
export default __webpack_public_path__ + "static/media/CheckIn.392358305f253235eb0bc15a76e02a63.svg";
export { ForwardRef as ReactComponent };